import { ajax } from '../../../services/helper'
class ApiService {

    getEmployeesData = (city_id,department_id,reporting_manager_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/list?city_id="+city_id+"&department_id="+department_id+"&reporting_manager_id="+reporting_manager_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    getEmployeesAttritionData = (from,to,status) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/EmployeeAttritions/list?from="+from+"&to="+to+"&status="+status+""
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }






    getCityDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/cities/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


 getRolesComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/roles/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
    getDesignationsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/designations/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     addEmployee = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

      getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


      getEmployeeAttritionById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeAttritions/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

     editEmployee = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
    

    getDepartmentsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departments/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getWorkLocationsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/workLocations/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    getEmployeesListData = (type) => {
        if(type===""){
            return new Promise((resolve, reject) => {
            const url = "/v1/employees/getCombo"
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }else{
            return new Promise((resolve, reject) => {
                const url = "/v1/employees/getCombo?type="+type
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }
        
    }    

     getKitchensDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    getAttritionReasonList = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/getCombo?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    } 

     addEmployeeAttrition = (data,employeeId) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+employeeId+"/attrite"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editEmployeeAttrition = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeAttritions/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    getDepartmentTeamsComboList = (id,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departmentTeams/getCombo?department_id="+id+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    validateEmployee = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/alreadyExistByValue"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    getEmployeeViewById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getEmployeeResourcessByEmployeeId = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/getResources"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
    
    
    getEntyTypesList = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityTypes/getCombo?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    

    deleteEmployeeResource = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/deleteResource"
               ajax(url,'POST')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
    }

    


     addEmployeeResource = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/addResource"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     editEmployeeResource = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/editResource"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }





    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Employees/services/apiservices.js